// extracted by mini-css-extract-plugin
module.exports = {"Back":"Back_Back__2j_x4","backImg":"Back_backImg__1nj0X"};